import Component from '@glimmer/component';
import { guidFor } from '@ember/object/internals';
import { hash } from '@ember/helper';
import FormFieldCheckbox from './form-field/checkbox.js';
import FormFieldFeedback from './form-field/feedback.js';
import FormFieldHint from './form-field/hint.js';
import FormFieldInput from './form-field/input.js';
import FormFieldLabel from './form-field/label.js';
import FormFieldRadio from './form-field/radio.js';
import FormFieldTextarea from './form-field/textarea.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

class FormField extends Component {
  id = guidFor(this);
  get hintId() {
    return this.id + '-hint';
  }
  get feedbackId() {
    return this.id + '-feedback';
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <div ...attributes>\n      {{yield (hash id=this.id hintId=this.hintId feedbackId=this.feedbackId Label=(component FormFieldLabel for=this.id size=@size) Hint=(component FormFieldHint id=this.hintId size=@size) Feedback=(component FormFieldFeedback id=this.feedbackId size=@size) Input=(component FormFieldInput id=this.id size=@size) Textarea=(component FormFieldTextarea id=this.id size=@size) Checkbox=(component FormFieldCheckbox id=this.id size=@size) Radio=(component FormFieldRadio id=this.id size=@size))}}\n    </div>\n  ", {
      strictMode: true,
      scope: () => ({
        hash,
        FormFieldLabel,
        FormFieldHint,
        FormFieldFeedback,
        FormFieldInput,
        FormFieldTextarea,
        FormFieldCheckbox,
        FormFieldRadio
      })
    }), this);
  }
}

export { FormField as default };
//# sourceMappingURL=form-field.js.map
